import { LoaderFunction, useFetcher } from "react-router-dom";
import { DecimalResult } from "../../../../common/api/decimal/utils.ts";
import {
  addFavorite,
  getFavoritesByVbid,
  removeFavorite,
} from "../../../../common/api/decimal/methods/favorites.ts";
import { Favorite } from "../../../../common/api/decimal/common-types/manageAssets.ts";

export const favorites: LoaderFunction = async ({
  request,
}): Promise<DecimalResult<unknown>> => {
  const formData = await request.formData();
  const method = request.method;
  const vbid = formData.get("vbid") as string;

  if (method === "PUT" && vbid) {
    return addFavorite(vbid);
  }
  if (method === "DELETE" && vbid) {
    return removeFavorite(vbid);
  }

  return Promise.resolve({ ok: false, meta: {} });
};

export function useFavoritesFetcher(key?: string) {
  return useFetcher<DecimalResult<unknown>>(key ? { key } : undefined);
}

export const favoritesByVbid: LoaderFunction = async ({
  request,
}): Promise<DecimalResult<unknown>> => {
  const url = new URL(request.url);
  const vbidsStr = url.searchParams.get("vbids");
  const vbids: string[] = vbidsStr?.split(",") ?? [];
  if (vbids.length) {
    return getFavoritesByVbid(vbids);
  } else {
    // empty lookup
    return Promise.resolve({ ok: true, meta: {}, data: {} });
  }
};

export const favoritesByVbidKey = "favorites-by-vbid";

export function useFavoritesByVbidFetcher(key?: string) {
  return useFetcher<DecimalResult<Record<string, Favorite>>>(
    key ? { key } : undefined
  );
}
